import { toBeDisabled } from "@testing-library/jest-dom/matchers";

const sections = {
  "CSL": [
    {
      title: "Contact Information",
      fields: [
        {
          label: "Law Firm",
          name: "law_firm",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Name",
          name: "bond_counsel_name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Email Address",
          name: "email_address",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond Counsel Phone Number",
          name: "phone_number",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal/Assistant Name",
          name: "Paralegal_Name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Paralegal Email Address",
          name: "Paralegal_EmailID",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal Phone Number",
          name: "Paralegal_Phone",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "AAG Name",
          name: "aag_name",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        ,
        {
          label: "Legal assistant Name",
          name: "legal_assistant",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "AAG Email Address",
          name: "aag_Email",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
      ],
    },
    {
      title: "Attachments",
      // No need for fields, as attachments are rendered dynamically
    },
    {
      title: "Public Security Information-I",
      fields: [
        {
          label: "Issuer",
          name: "Issuer",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issuance Title",
          name: "title",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Year",
          name: "issue_year",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Security Type",
          name: "security_type",
          type: "select",
          visible: false,
          isDisabled: false
        },
        {
          label: "Issue/Opinion Number",
          name: "bond_issue_number",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Name",
          name: "issue_name",
          type: "text",
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Transcript Completed",
          name: "is_transcript_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond  Status",
          name: "bond_status",
          type: "select",
          options: ["New", "Cancelled", "Opinion Issued", "Under Review", "Registered", "Delayed"],
          optionvalue: ["N", "C", "O", "P", "R", "D"],
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Issued",
          name: "is_opinion_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Registered",
          name: "is_registration_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },

        {
          label: "Par Dollar Amount ($)",
          name: "par_dollar_amount",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee amount Due($)",
          name: "fee_amount_due",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee Amount Paid Date",
          name: "fee_amount_paid",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Interest Type",
          name: "interest_type",
          type: "select",
          visible: true,
          isDisabled: false
        },

        // {
        //   label: "Fee Transaction Number",
        //   name: "Fee_Transaction_Number",
        //   type: "text",
        //   editable: true,
        //   visible: true,
        //   isDisabled:false
        // },
        {
          label: "Traditional or Conduit",
          name: "traditional_or_conduit",
          type: "select",
          options: ["Traditional", "Conduit"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Closing Date",
          name: "closing_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Requested Date",
          name: "opinion_requested_by",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Due Date",
          name: "opinion_due_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Preliminary Letter Requested",
          name: "preliminary_letter_requested",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Submission Date",
          name: "submission_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Authority",
          name: "authority",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Multiple Series",
          name: "related_bond",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        }
      ],
    },
    {
      title: "Public Security Information-II",
      fields: [
        {
          label: "TEFRA Opinion",
          name: "tefra_opinion",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "TX Water Development Board",
          name: "twdb",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "1371 Proceedings",
          name: "1371_proceedings",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Is Public Security Included?",
          name: "is_public_security_included",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Boundary Change",
          name: "annexation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Creation",
          name: "creation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Election",
          name: "election",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Refunding",
          name: "refunding",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "TX Education Agency",
          name: "is_tea",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },

      ],
    },
  ],
  "OAG": [
    {
      title: "Contact Information",
      fields: [
        {
          label: "Law Firm",
          name: "law_firm",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Name",
          name: "bond_counsel_name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Email Address",
          name: "email_address",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond Counsel Phone Number",
          name: "phone_number",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal/Assistant Name",
          name: "Paralegal_Name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Paralegal Email Address",
          name: "Paralegal_EmailID",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal Phone Number",
          name: "Paralegal_Phone",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "AAG Name",
          name: "aag_name",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Legal assistant Name",
          name: "legal_assistant",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "AAG Email Address",
          name: "aag_Email",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
      ],
    },
    {
      title: "Attachments",
      // No need for fields, as attachments are rendered dynamically
    },
    {
      title: "Public Security Information-I",
      fields: [
        {
          label: "Issuer",
          name: "Issuer",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issuance Title",
          name: "title",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Comments",
          name: "comments",
          type: "textarea",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Year",
          name: "issue_year",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Security Type",
          name: "security_type",
          type: "select",
          visible: false,
          isDisabled: false
        },
        {
          label: "Issue/Opinion Number",
          name: "bond_issue_number",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Name",
          name: "issue_name",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Transcript Completed",
          name: "is_transcript_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false,
          msg: "Are you sure you want to mark the transcript as complete? You will not be able to edit the fields anymore.."
        },
        {
          label: "Bond  Status",
          name: "bond_status",
          type: "select",
          options: ["New", "Cancelled", "Opinion Issued", "Under Review", "Registered", "Delayed"],
          optionvalue: ["N", "C", "O", "P", "R", "D"],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Issued",
          name: "is_opinion_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false,
          msg: "Are you sure you want to mark the Opinion as complete? You will not be able to edit the fields anymore.."
        },
        {
          label: "Registered",
          name: "is_registration_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false,
          msg: "Are you sure you want to mark the Registration as complete? You will not be able to edit the fields anymore.."
        },
        {
          label: "Par Dollar Amount ($)",
          name: "par_dollar_amount",
          type: "number",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee amount Due($)",
          name: "fee_amount_due",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee Amount Paid Date",
          name: "fee_amount_paid",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Interest Type",
          name: "interest_type",
          type: "select",
          visible: true,
          isDisabled: false
        },
        // {
        //   label: "Fee Transaction Number",
        //   name: "Fee_Transaction_Number",
        //   type: "text",
        //   editable: true,
        //   visible: true,
        //   isDisabled:false
        // },
        {
          label: "Traditional or Conduit",
          name: "traditional_or_conduit",
          type: "select",
          options: ["Traditional", "Conduit"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Closing Date",
          name: "closing_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Requested Date",
          name: "opinion_requested_by",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Due Date",
          name: "opinion_due_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Preliminary Letter Requested",
          name: "preliminary_letter_requested",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Submission Date",
          name: "submission_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Authority",
          name: "authority",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Multiple Series",
          name: "related_bond",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        }
      ],
    },
    {
      title: "Public Security Information-II",
      fields: [
        {
          label: "TEFRA Opinion",
          name: "tefra_opinion",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "TX Water Development Board",
          name: "twdb",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "1371 Proceedings",
          name: "1371_proceedings",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Is Public Security Included?",
          name: "is_public_security_included",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Boundary Change",
          name: "annexation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Creation",
          name: "creation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Election",
          name: "election",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Refunding",
          name: "refunding",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "TX Education Agency",
          name: "is_tea",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },

      ],
    },
  ],
  "BRB": [
    {
      title: "Contact Information",
      fields: [
        {
          label: "Law Firm",
          name: "law_firm",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Name",
          name: "bond_counsel_name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Email Address",
          name: "email_address",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond Counsel Phone Number",
          name: "phone_number",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal/Assistant Name",
          name: "Paralegal_Name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Paralegal Email Address",
          name: "Paralegal_EmailID",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal Phone Number",
          name: "Paralegal_Phone",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "AAG Name",
          name: "aag_name",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        ,
        {
          label: "Legal assistant Name",
          name: "legal_assistant",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "AAG Email Address",
          name: "aag_Email",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
      ],
    },
    {
      title: "Attachments",
      // No need for fields, as attachments are rendered dynamically
    },
    {
      title: "Public Security Information-I",
      fields: [
        {
          label: "Issuer",
          name: "Issuer",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issuance Title",
          name: "title",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Year",
          name: "issue_year",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Security Type",
          name: "security_type",
          type: "select",
          visible: false,
          isDisabled: false
        },
        {
          label: "Issue/Opinion Number",
          name: "bond_issue_number",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Name",
          name: "issue_name",
          type: "text",
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Transcript Completed",
          name: "is_transcript_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond  Status",
          name: "bond_status",
          type: "select",
          options: ["New", "Cancelled", "Opinion Issued", "Under Review", "Registered", "Delayed"],
          optionvalue: ["N", "C", "O", "P", "R", "D"],
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Issued",
          name: "is_opinion_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Registered",
          name: "is_registration_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },

        {
          label: "Par Dollar Amount ($)",
          name: "par_dollar_amount",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee amount Due($)",
          name: "fee_amount_due",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee Amount Paid Date",
          name: "fee_amount_paid",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Interest Type",
          name: "interest_type",
          type: "select",
          visible: true,
          isDisabled: false
        },

        // {
        //   label: "Fee Transaction Number",
        //   name: "Fee_Transaction_Number",
        //   type: "text",
        //   editable: true,
        //   visible: true,
        //   isDisabled:false
        // },
        {
          label: "Traditional or Conduit",
          name: "traditional_or_conduit",
          type: "select",
          options: ["Traditional", "Conduit"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Closing Date",
          name: "closing_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Requested Date",
          name: "opinion_requested_by",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Due Date",
          name: "opinion_due_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Preliminary Letter Requested",
          name: "preliminary_letter_requested",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Submission Date",
          name: "submission_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Authority",
          name: "authority",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Multiple Series",
          name: "related_bond",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        }
      ],
    },
    {
      title: "Public Security Information-II",
      fields: [
        {
          label: "TEFRA Opinion",
          name: "tefra_opinion",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "TX Water Development Board",
          name: "twdb",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "1371 Proceedings",
          name: "1371_proceedings",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Is Public Security Included?",
          name: "is_public_security_included",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Boundary Change",
          name: "annexation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Creation",
          name: "creation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Election",
          name: "election",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Refunding",
          name: "refunding",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "TX Education Agency",
          name: "is_tea",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },

      ],
    },
  ],
  "MAC": [
    {
      title: "Contact Information",
      fields: [
        {
          label: "Law Firm",
          name: "law_firm",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Name",
          name: "bond_counsel_name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Email Address",
          name: "email_address",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond Counsel Phone Number",
          name: "phone_number",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal/Assistant Name",
          name: "Paralegal_Name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Paralegal Email Address",
          name: "Paralegal_EmailID",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal Phone Number",
          name: "Paralegal_Phone",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "AAG Name",
          name: "aag_name",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        ,
        {
          label: "Legal assistant Name",
          name: "legal_assistant",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "AAG Email Address",
          name: "aag_Email",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
      ],
    },
    {
      title: "Attachments",
      // No need for fields, as attachments are rendered dynamically
    },
    {
      title: "Public Security Information-I",
      fields: [
        {
          label: "Issuer",
          name: "Issuer",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issuance Title",
          name: "title",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Year",
          name: "issue_year",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Security Type",
          name: "security_type",
          type: "select",
          visible: false,
          isDisabled: false
        },
        {
          label: "Issue/Opinion Number",
          name: "bond_issue_number",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Name",
          name: "issue_name",
          type: "text",
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Transcript Completed",
          name: "is_transcript_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond  Status",
          name: "bond_status",
          type: "select",
          options: ["New", "Cancelled", "Opinion Issued", "Under Review", "Registered", "Delayed"],
          optionvalue: ["N", "C", "O", "P", "R", "D"],
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Issued",
          name: "is_opinion_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Registered",
          name: "is_registration_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },

        {
          label: "Par Dollar Amount ($)",
          name: "par_dollar_amount",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee amount Due($)",
          name: "fee_amount_due",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee Amount Paid Date",
          name: "fee_amount_paid",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Interest Type",
          name: "interest_type",
          type: "select",
          visible: true,
          isDisabled: false
        },

        // {
        //   label: "Fee Transaction Number",
        //   name: "Fee_Transaction_Number",
        //   type: "text",
        //   editable: true,
        //   visible: true,
        //   isDisabled:false
        // },
        {
          label: "Traditional or Conduit",
          name: "traditional_or_conduit",
          type: "select",
          options: ["Traditional", "Conduit"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Closing Date",
          name: "closing_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Requested Date",
          name: "opinion_requested_by",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Due Date",
          name: "opinion_due_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Preliminary Letter Requested",
          name: "preliminary_letter_requested",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Submission Date",
          name: "submission_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Authority",
          name: "authority",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Multiple Series",
          name: "related_bond",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        }
      ],
    },
    {
      title: "Public Security Information-II",
      fields: [
        {
          label: "TEFRA Opinion",
          name: "tefra_opinion",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "TX Water Development Board",
          name: "twdb",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "1371 Proceedings",
          name: "1371_proceedings",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Is Public Security Included?",
          name: "is_public_security_included",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Boundary Change",
          name: "annexation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Creation",
          name: "creation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Election",
          name: "election",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Refunding",
          name: "refunding",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "TX Education Agency",
          name: "is_tea",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },

      ],
    },
  ],
  "TWB": [
    {
      title: "Contact Information",
      fields: [
        {
          label: "Law Firm",
          name: "law_firm",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Name",
          name: "bond_counsel_name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Email Address",
          name: "email_address",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond Counsel Phone Number",
          name: "phone_number",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal/Assistant Name",
          name: "Paralegal_Name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Paralegal Email Address",
          name: "Paralegal_EmailID",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal Phone Number",
          name: "Paralegal_Phone",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "AAG Name",
          name: "aag_name",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        ,
        {
          label: "Legal assistant Name",
          name: "legal_assistant",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "AAG Email Address",
          name: "aag_Email",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
      ],
    },
    {
      title: "Attachments",
      // No need for fields, as attachments are rendered dynamically
    },
    {
      title: "Public Security Information-I",
      fields: [
        {
          label: "Issuer",
          name: "Issuer",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issuance Title",
          name: "title",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Year",
          name: "issue_year",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Security Type",
          name: "security_type",
          type: "select",
          visible: false,
          isDisabled: false
        },
        {
          label: "Issue/Opinion Number",
          name: "bond_issue_number",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Name",
          name: "issue_name",
          type: "text",
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Transcript Completed",
          name: "is_transcript_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond  Status",
          name: "bond_status",
          type: "select",
          options: ["New", "Cancelled", "Opinion Issued", "Under Review", "Registered", "Delayed"],
          optionvalue: ["N", "C", "O", "P", "R", "D"],
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Issued",
          name: "is_opinion_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Registered",
          name: "is_registration_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },

        {
          label: "Par Dollar Amount ($)",
          name: "par_dollar_amount",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee amount Due($)",
          name: "fee_amount_due",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee Amount Paid Date",
          name: "fee_amount_paid",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Interest Type",
          name: "interest_type",
          type: "select",
          visible: true,
          isDisabled: false
        },

        // {
        //   label: "Fee Transaction Number",
        //   name: "Fee_Transaction_Number",
        //   type: "text",
        //   editable: true,
        //   visible: true,
        //   isDisabled:false
        // },
        {
          label: "Traditional or Conduit",
          name: "traditional_or_conduit",
          type: "select",
          options: ["Traditional", "Conduit"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Closing Date",
          name: "closing_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Requested Date",
          name: "opinion_requested_by",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Due Date",
          name: "opinion_due_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Preliminary Letter Requested",
          name: "preliminary_letter_requested",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Submission Date",
          name: "submission_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Authority",
          name: "authority",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Multiple Series",
          name: "related_bond",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        }
      ],
    },
    {
      title: "Public Security Information-II",
      fields: [
        {
          label: "TEFRA Opinion",
          name: "tefra_opinion",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "TX Water Development Board",
          name: "twdb",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "1371 Proceedings",
          name: "1371_proceedings",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Is Public Security Included?",
          name: "is_public_security_included",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Boundary Change",
          name: "annexation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Creation",
          name: "creation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Election",
          name: "election",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Refunding",
          name: "refunding",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "TX Education Agency",
          name: "is_tea",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },

      ],
    },
  ],
  "TEA": [
    {
      title: "Contact Information",
      fields: [
        {
          label: "Law Firm",
          name: "law_firm",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Name",
          name: "bond_counsel_name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Bond Counsel Email Address",
          name: "email_address",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond Counsel Phone Number",
          name: "phone_number",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal/Assistant Name",
          name: "Paralegal_Name",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Paralegal Email Address",
          name: "Paralegal_EmailID",
          type: "email",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Paralegal Phone Number",
          name: "Paralegal_Phone",
          type: "phone",
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "AAG Name",
          name: "aag_name",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        ,
        {
          label: "Legal assistant Name",
          name: "legal_assistant",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "AAG Email Address",
          name: "aag_Email",
          type: "text",
          editable: false,
          visible: false,
          isDisabled: false
        },
      ],
    },
    {
      title: "Attachments",
      // No need for fields, as attachments are rendered dynamically
    },
    {
      title: "Public Security Information-I",
      fields: [
        {
          label: "Issuer",
          name: "Issuer",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issuance Title",
          name: "title",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Year",
          name: "issue_year",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Security Type",
          name: "security_type",
          type: "select",
          visible: false,
          isDisabled: false
        },
        {
          label: "Issue/Opinion Number",
          name: "bond_issue_number",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Issue Name",
          name: "issue_name",
          type: "text",
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Transcript Completed",
          name: "is_transcript_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "Bond  Status",
          name: "bond_status",
          type: "select",
          options: ["New", "Cancelled", "Opinion Issued", "Under Review", "Registered", "Delayed"],
          optionvalue: ["N", "C", "O", "P", "R", "D"],
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Issued",
          name: "is_opinion_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },
        {
          label: "Registered",
          name: "is_registration_complete",
          type: "select",
          options: ["No", "Yes"],
          optionvalue: ["No", "Yes"],
          editable: false,
          visible: false,
          isDisabled: false
        },

        {
          label: "Par Dollar Amount ($)",
          name: "par_dollar_amount",
          type: "number",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee amount Due($)",
          name: "fee_amount_due",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Fee Amount Paid Date",
          name: "fee_amount_paid",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Interest Type",
          name: "interest_type",
          type: "select",
          visible: true,
          isDisabled: false
        },

        // {
        //   label: "Fee Transaction Number",
        //   name: "Fee_Transaction_Number",
        //   type: "text",
        //   editable: true,
        //   visible: true,
        //   isDisabled:false
        // },
        {
          label: "Traditional or Conduit",
          name: "traditional_or_conduit",
          type: "select",
          options: ["Traditional", "Conduit"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Closing Date",
          name: "closing_date",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Requested Date",
          name: "opinion_requested_by",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Opinion Due Date",
          name: "opinion_due_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Preliminary Letter Requested",
          name: "preliminary_letter_requested",
          type: "date",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Submission Date",
          name: "submission_date",
          type: "date",
          editable: false,
          visible: true,
          isDisabled: false
        },
        {
          label: "Authority",
          name: "authority",
          type: "text",
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Multiple Series",
          name: "related_bond",
          type: "text",
          editable: false,
          visible: true,
          isDisabled: false
        }
      ],
    },
    {
      title: "Public Security Information-II",
      fields: [
        {
          label: "TEFRA Opinion",
          name: "tefra_opinion",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "TX Water Development Board",
          name: "twdb",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "1371 Proceedings",
          name: "1371_proceedings",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Is Public Security Included?",
          name: "is_public_security_included",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Boundary Change",
          name: "annexation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Creation",
          name: "creation",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Election",
          name: "election",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },
        {
          label: "Refunding",
          name: "refunding",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: false,
          isDisabled: false
        },
        {
          label: "TX Education Agency",
          name: "is_tea",
          type: "radio",
          options: ["No", "Yes"],
          optionvalue: [0, 1],
          editable: true,
          visible: true,
          isDisabled: false
        },

      ],
    },
  ]
}

export default sections;